import { render, staticRenderFns } from "./AddClassifyDialog.vue?vue&type=template&id=04624e8f&scoped=true&"
import script from "./AddClassifyDialog.vue?vue&type=script&lang=js&"
export * from "./AddClassifyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04624e8f",
  null
  
)

export default component.exports